module.exports = __webpack_public_path__ + "img/Rectangle 1.99b20acb.png";